import { getMakeIcon, getBodyStyleIcon } from "@talladega/helpers";
import classNames from "classnames";

type Props = {
  size?: "xs" | "sm" | "md" | "lg" | "full";
  className?: string;
  year?: number;
  make?: string;
  bodyStyle?: string;
  rounded?: boolean;
};

const avatarSizeClass = ({ size }: Props) => {
  switch (size) {
    case "xs":
      return "h-12 w-12 text-2xl";
    case "sm":
      return "h-20 w-20 text-4xl";
    case "md":
      return "h-24 w-24 text-5xl";
    case "lg":
      return "h-28 w-28 text-6xl";
    case "full":
      return "h-28 w-full text-2xl";
    default:
      return "h-20 w-20 text-4xl";
  }
};

export const VehicleAvatar = ({
  size = "md",
  className,
  year,
  make,
  bodyStyle,
  rounded = true,
}: Props) => {
  const defaultAvatar = (
    <span className="font-semibold">
      {`'${year?.toString().substring(2, 4)}`}
    </span>
  );

  const MakeIcon = getMakeIcon(make || "");
  const BodyStyleIcon = getBodyStyleIcon(bodyStyle || "");

  return (
    <div
      className={classNames(
        "inline-flex items-center justify-center p-2",
        avatarSizeClass({ size }),
        {
          "rounded-full": rounded,
          "rounded-xl": !rounded,
          "bg-secondary-100 text-primary-500 kijiji:bg-info kijiji:text-white":
            year && !make && !bodyStyle,
          "bg-gray-50 kijiji:bg-gray-300": make || bodyStyle,
        },
        className
      )}
    >
      {(make && (
        <MakeIcon
          className={classNames(
            "text-primary-500",
            avatarSizeClass({ size }),
            className
          )}
        />
      )) ||
        (bodyStyle && (
          <BodyStyleIcon
            className={classNames(
              "text-primary-500",
              avatarSizeClass({ size }),
              className
            )}
          />
        )) ||
        (year && defaultAvatar) ||
        null}
    </div>
  );
};

export default {};
